(function () {
  "use strict";

  function initializeSlider() {
    const sliderElements = document.querySelectorAll(".product-item-meta__swatch-list");

    if (sliderElements.length) {
      sliderElements.forEach((sliderElement) => {
        if (!sliderElement.classList.contains("slick-initialized")) {

          window.jQuery(sliderElement).slick({
            dots: false,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 2,
            prevArrow: `
              <button class="options--button-previous" type="button" data-round-image-links-button-previous>
                <svg class="svg-icon" style="width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M803.342997 87.013896a47.908827 47.908827 0 0 0 0-70.993102A61.421574 61.421574 0 0 0 723.904429 13.256823l-3.173448 2.763971L241.23323 470.949915l-2.405678 1.842647c-1.637909 1.228431-3.173448 2.559232-4.606618 3.941218-20.013196 18.938319-20.985704 48.113566-2.86634 68.075577l2.815155 2.917525 484.820954 459.945216c22.521244 21.343997 60.090773 21.343997 82.612016 0 20.013196-18.938319 20.985704-48.113566 2.86634-68.075577l-2.86634-2.968709-446.893132-423.911227L803.342997 87.013896z"/>
                </svg>
              </button>
            `,
            nextArrow: `
              <button class="options--button-next" type="button" data-round-image-links-button-next>
                <svg class="svg-icon" style="width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M341.957209 959.354678c-12.893658 0-25.842575-4.425799-36.386722-13.467733-23.493064-20.10592-26.224268-55.426357-6.064113-78.891791L603.929736 511.789199l-304.423361-355.206978c-20.160155-23.465434-17.427928-58.786894 6.064113-78.891791 23.437805-20.024056 58.786894-17.373693 78.837556 6.064113l335.675132 391.620305c17.974373 20.952194 17.974373 51.875484 0 72.827679l-335.675132 391.620305C373.371686 952.717514 357.691565 959.354678 341.957209 959.354678z"/>
                </svg>
              </button>
            `,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              }
            ]
          });
        }
      });
    }
  }

  function main() {
    let i = 0;
    
    const intervalId = setInterval(() => {
      console.log("trying", i);
      i += 1;
      if (typeof(window.jQuery) === "function" && typeof(window.jQuery.fn.slick) === "function") {
        clearInterval(intervalId);
        initializeSlider();
      }
    }, 200);
    document.addEventListener("product-recommendations-rendered", () => {
      initializeSlider();
    })
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", main, { once: true });
  } else {
    main();
  }

  const script1 = document.createElement("script");
  script1.src = "https://code.jquery.com/jquery-3.6.0.min.js";
  script1.async = true;
  script1.onload = () => {
    const script2 = document.createElement("script");
    script2.src = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js";
    script2.async = true;
    document.head.append(script2);
  };
  document.head.append(script1);

  const stylesheet1 = document.createElement("link");
  stylesheet1.rel = "stylesheet";
  stylesheet1.href = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css";
  document.head.append(stylesheet1);
  
  const stylesheet2 = document.createElement("link");
  stylesheet2.rel = "stylesheet";
  stylesheet2.href = "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css";
  document.head.append(stylesheet2);
})();